/**
 * A redirect sign-in that the identity provider refused or that could not be completed. The
 * message is meant for the user: the provider's `error_description` when there is one.
 */
export class SignInError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'SignInError';
    }
}
//# sourceMappingURL=SignInError.js.map